<template>
  <div>
    <query-form labelWidth="130px" class="content_block" ref="queryForm" @search="handleSearch" @reset="handleReset">
      <el-form-item label="企业名称：">
        <el-input placeholder="请输入企业名称" v-model.trim="query.name" clearable></el-input>
      </el-form-item>
      <el-form-item label="认证状态：">
        <el-select v-model="query.authenticationStatus" clearable placeholder="请选择认证状态" @change="handleChange">
          <el-option
            v-for="i in AuthStatusList"
            :key="i.value"
            :label="i.name"
            :value="i.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建人手机号：">
        <el-input placeholder="请输入创建人手机号" v-model.trim="query.createUserPhone" clearable></el-input>
      </el-form-item>
      <el-form-item label="是否为邀请创建：">
        <el-select v-model="query.inviteCreateFlag" collapse-tags clearable @change="handleChange" placeholder="请选择">
          <el-option label="否" value="0"></el-option>
          <el-option label="是" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="企业编号：">
        <el-input placeholder="请输入企业编号" v-model.trim="query.code" clearable></el-input>
      </el-form-item>
      <el-form-item label="创建起始时间：">
        <el-date-picker v-model="query.createStartTime" type="datetime" value-format="timestamp" style="width: 100%;" placeholder="请选择创建起始时间" popper-class="xzpt" clearable></el-date-picker>
      </el-form-item>
      <el-form-item label="创建结束时间：">
        <el-date-picker v-model="query.createEndTime" type="datetime" value-format="timestamp" style="width: 100%;" placeholder="请选择创建结束时间" popper-class="xzpt" clearable></el-date-picker>
      </el-form-item>
      <el-form-item label="认证起始时间：">
        <el-date-picker v-model="query.authenticationStartTime" type="datetime" value-format="timestamp" style="width: 100%;" placeholder="请选择认证起始时间" popper-class="xzpt" clearable></el-date-picker>
      </el-form-item>
      <el-form-item label="认证结束时间：">
        <el-date-picker v-model="query.authenticationEndTime" type="datetime" value-format="timestamp" style="width: 100%;" placeholder="请选择认证结束时间" popper-class="xzpt" clearable></el-date-picker>
      </el-form-item>
      <el-form-item label="创建人姓名：">
        <el-input placeholder="请输入创建人姓名" v-model.trim="query.createUserName" clearable></el-input>
      </el-form-item>
      <el-form-item label="开通服务：">
        <el-select v-model="query.activateServices" multiple collapse-tags clearable @change="handleChange" placeholder="请选择开通服务">
          <el-option
            v-for="i in [
              { label: 'SCA', value: 'SCA' },
              { label: '医修保', value: '医修保' },
              { label: '小紫VIS', value: '小紫VIS' },
            ]"
            :key="i.value"
            :label="i.label"
            :value="i.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="经营类型：">
        <el-select v-model="query.businessTypes" multiple collapse-tags clearable @change="handleChange" placeholder="请选择经营类型">
          <el-option
            v-for="i in businessOptions"
            :key="i.value"
            :label="i.name"
            :value="i.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </query-form>
    <table-with-pagination
      :tableData="tenantList"
      class="content_block"
      :columnList="columnList"
      :pagination.sync="pagination"
      :sortInfo.sync="createTimeSortInfo"
      @size-change="getTableList"
      @current-change="getTableList"
      @sort-change="handleSearch"
    />
    <EnableAndDisableDialog ref="JZEnableAndDisableDialog" @handleRefresh="handleReset"></EnableAndDisableDialog>
  </div>
</template>
<script>
import { getTenantList, activeV2 } from '@/api/tenant';
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
import { dateFormat } from '@/utils/dateFormat';
import registerSourceEnum from '@/model/xzpt/registerSource';
import AuthEnum, { AuthStatusList } from '@/model/xzpt/auth';
import BusinessTypeEnum, { BusinessTypes } from '@/model/xzpt/businessTypes';
import EnableAndDisableDialog from '@/views/xzpt/employee/components/enableAndDisableDialog.vue';
export default {
  name: 'TENANT_INDEX',
  mixins: [TablePaginationMixin],
  components: {
    TableWithPagination,
    EnableAndDisableDialog,
  },
  data () {
    return {
      query: {
        name: '',
        authenticationStatus: '',
        createUserPhone: '',
        inviteCreateFlag: '',
        code: '',
        createStartTime: '',
        createEndTime: '',
        authenticationStartTime: '',
        authenticationEndTime: '',
        createUserName: '',
        activateServices: [],
        businessTypes: [],
      },
      AuthStatusList: [
        { value: '', name: '全部' },
        ...AuthStatusList,
      ],
      businessOptions: BusinessTypes,
      tenantList: [],
      columnList: [
        {
          tooltip: true,
          label: '创建应用端',
          minWidth: '100px',
          prop: 'registerSource',
          format: (v) => {
            return registerSourceEnum[v];
          },
        },
        {
          tooltip: true,
          label: '企业编号',
          minWidth: '150px',
          prop: 'code',
        },
        {
          tooltip: true,
          label: '企业名称',
          minWidth: '150px',
          prop: 'name',
        },
        {
          tooltip: true,
          label: '经营类型',
          minWidth: '150px',
          prop: 'businessType',
          format: (v) => {
            if (v) {
              const valArr = v.split(',');

              return valArr.map(v => BusinessTypeEnum[v]).join(',');
            }
          },
        },
        {
          tooltip: true,
          label: '创建时间',
          minWidth: '150px',
          prop: 'createTime',
          sortable: true,
          format: v => {
            return v ? dateFormat(v).format('YYYY-MM-DD HH:mm:ss') : '--';
          },
        },
        {
          tooltip: true,
          label: '认证状态',
          minWidth: '150px',
          prop: 'authenticationStatus',
          format: (v) => {
            return AuthEnum[v];
          },
        },
        {
          tooltip: true,
          label: '创建人姓名',
          minWidth: '150px',
          prop: 'applicantName',
        },
        {
          tooltip: true,
          label: '创建人手机号',
          minWidth: '150px',
          prop: 'applicantPhoneNumber',
        },
        {
          tooltip: true,
          label: '是否为邀请创建',
          minWidth: '130px',
          prop: 'inviteCreateFlagDesc',
        },
        {
          tooltip: true,
          label: '开通服务',
          minWidth: '150px',
          prop: 'activateService',
        },
        {
          tooltip: true,
          label: '账号状态',
          minWidth: '150px',
          prop: 'trialStatusDesc',
        },
        {
          label: '操作',
          minWidth: '150px',
          fixed: 'right',
          render: (h, { row }) => {
            let actions = [];
            actions.push(
              <span
                class="table-action"
                onClick={this.handleActionClick.bind(this, row, 'check')}
              >
                查看
              </span>,
            );
            if (['disabled', 'banned'].includes(row.trialStatus)) {
              actions.push(
                <span
                  class="table-action"
                  onClick={this.handleActivate.bind(this, row)}
                >
                激活
                </span>,
              );
            }
            if (['use'].includes(row.trialStatus)) {
              actions.push(
                <span
                  class="table-action"
                  onClick={this.handleDisable.bind(this, row)}
                >
                禁用
                </span>,
              );
              actions.push(
                <span
                  class="table-action"
                  onClick={this.handleBan.bind(this, row)}
                >
                封禁
                </span>,
              );
            }
            return <div>{...actions}</div>;
          },
        },
      ],
    };
  },
  methods: {
    async handleActivate ({ id }) {
      await activeV2({id});

      this.$message.success('激活成功成功');

      this.getTableList();
    },

    handleBan ({ id, name }) {
      this.$refs.JZEnableAndDisableDialog.msg = name;
      this.$refs.JZEnableAndDisableDialog.dialogTitle = '确认封禁';
      this.$refs.JZEnableAndDisableDialog.tenantId = id;
      this.$refs.JZEnableAndDisableDialog.initPage();
    },

    handleDisable ({ id, name }) {
      this.$refs.JZEnableAndDisableDialog.msg = name;
      this.$refs.JZEnableAndDisableDialog.dialogTitle = '确认禁用';
      this.$refs.JZEnableAndDisableDialog.tenantId = id;
      this.$refs.JZEnableAndDisableDialog.initPage();
    },
    handleActionClick ({ id }, action) {
      if (action === 'check') {
        this.$router.push({
          name: 'XZPT_Company_Detail',
          query: {
            id,
          },
        });
      }
    },
    handleSearch () {
      this.pagination.currentPage = 1;
      this.getTableList();
    },
    handleReset () {
      this.query = {
        name: '',
        phoneNumber: '',
        comparisonOperator: '',
        tenantNum: '',
        registerSource: '',
        registerType: '',
        startTime: '',
        endTime: '',
      };
      this.handleSearch();
    },
    getTableList () {
      const query = {};

      for (let k in this.query) {
        if (this.query[k]) {
          query[k] = this.query[k];
        }
      }

      let param = {
        ...query,
        inviteCreateFlag: query.inviteCreateFlag === '' ? null : Number(query.inviteCreateFlag),
        orderBy: [this.createTimeSortInfo],
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.currentPage,
      };

      getTenantList(param).then(res => {
        this.tenantList = res.body.list;
        this.pagination.total = res.body.total;
      });
    },

    handleChange () {
      this.pagination.currentPage = 1;

      this.getTableList();
    },
  },
};
</script>
